import React, { ReactNode } from "react";
import cx from "classnames";

import styles from "./index.module.scss";

interface TitleProps {
  children: ReactNode;
  className?: string;
  variant?: "XL" | "L" | "M" | "S" | "XS";
}

// Mapping variant to corresponding heading tag
const variantTagMap: Record<
  NonNullable<TitleProps["variant"]>,
  keyof React.JSX.IntrinsicElements
> = {
  XL: "h1",
  L: "h2",
  M: "h3",
  S: "h4",
  XS: "h5"
};

const Title: React.FC<TitleProps> = ({ children, className = "", variant = "M" }) => {
  const Tag = variantTagMap[variant];

  return <Tag className={cx(styles[variant], className)}>{children}</Tag>;
};

export default Title;
